import { render, staticRenderFns } from "./CollapseExpandButton.vue?vue&type=template&id=a6ed37e4&scoped=true&"
import script from "./CollapseExpandButton.vue?vue&type=script&lang=js&"
export * from "./CollapseExpandButton.vue?vue&type=script&lang=js&"
import style0 from "./CollapseExpandButton.vue?vue&type=style&index=0&id=a6ed37e4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ed37e4",
  null
  
)

export default component.exports